import React, { useState, useEffect } from "react";

const skills = [
  { name: "Framer", category: "Frontend", icon: "/Framer.webp", color: "from-blue-300 to-blue-300", },
  { name: "GSAP", category: "Frontend", icon:"/gsap.jpeg", color: "from-blue-300 to-blue-300", level: 70 },
  { name: "Git", category: "Frontend", icon:"/git.png", color: "from-blue-300 to-blue-300", level: 70 },
  { name: "NPM", category: "Frontend", icon:"/npm.jpeg", color: "from-blue-300 to-blue-300", level: 20 },
  { name: "Typescript", category: "Frontend", icon:"/typscript.png", color: "from-blue-300 to-blue-300", level: 60 },
  // { name: "REST API", category: "Backend", color: "from-blue-300 to-blue-300", level: 50 },
  // { name: "MERN", category: "Backend", color: "from-blue-300 to-blue-300", level: 70 },
  // { name: "Java", category: "DSA", color: "from-blue-300 to-blue-300", level: 40 },
  // { name: "MongoDB", category: "Database", color: "from-blue-300 to-blue-300", level: 70 },
  // { name: "DSA", category: "LeetCode", color: "from-blue-300 to-blue-300", level: 20 },
];

const Page5 = () => {
  const [visibleSkills, setVisibleSkills] = useState([]);
  const [selectedCategory] = useState("All");

  // const categories = ["All", "Frontend", "Backend", "DSA", "LeetCode"];

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisibleSkills(skills.map((_, index) => index));
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const filteredSkills = selectedCategory === "All" 
    ? skills 
    : skills.filter(skill => skill.category === selectedCategory);

  return (
    <div className="min-h-screen p-5 md:px-5 py-6  overflow-hidden">
      <div className="relative w-full  mx-auto  overflow-hidden rounded-[50px] backdrop-blur-md border border-white/10">
        <div className="absolute inset-0 bg-black">
          {/* Starfield */}
          <div className="absolute inset-0">
            {[...Array(150)].map((_, i) => (
              <div
                key={`star-${i}`}
                className="absolute bg-white rounded-full animate-twinkle"
                style={{
                  width: `${Math.random() * 3 + 1}px`,
                  height: `${Math.random() * 3 + 1}px`,
                  left: `${Math.random() * 100}%`,
                  top: `${Math.random() * 100}%`,
                  animationDelay: `${Math.random() * 5}s`,
                  animationDuration: `${2 + Math.random() * 3}s`
                }}
              />
            ))}
          </div>

          {/* Border Frame */}
          <div className="absolute inset-4 border-2 rounded-[50px] border-white/30"></div>

          {/* Geometric Shapes */}
          <div className="absolute inset-0 overflow-hidden">
            {/* Large Geodesic Sphere - Bottom Left */}
            <div className="absolute bottom-0 left-0 w-80 h-80 transform -translate-x-1/2 translate-y-1/2">
              <svg viewBox="0 0 200 200" className="w-full h-full stroke-white/30 fill-none animate-slow-rotate">
                <polygon points="100,20 180,60 160,140 40,140 20,60" strokeWidth="1"/>
                <polygon points="100,20 140,50 120,80 80,80 60,50" strokeWidth="1"/>
                <polygon points="60,50 80,80 70,110 30,110 20,80" strokeWidth="1"/>
                <polygon points="140,50 180,80 170,110 130,110 120,80" strokeWidth="1"/>
                <polygon points="70,110 130,110 120,140 50,140 30,110" strokeWidth="1"/>
                <line x1="100" y1="20" x2="100" y2="50" strokeWidth="1"/>
                <line x1="60" y1="50" x2="140" y2="50" strokeWidth="1"/>
                <line x1="70" y1="110" x2="130" y2="110" strokeWidth="1"/>
              </svg>
            </div>

            {/* Floating Cubes */}
            <div className="absolute top-1/4 left-1/4 w-12 h-12 animate-float-slow">
              <svg viewBox="0 0 100 100" className="w-full h-full stroke-white/40 fill-none">
                <polygon points="25,25 75,25 90,40 40,40" strokeWidth="2"/>
                <polygon points="25,25 40,40 40,90 25,75" strokeWidth="2"/>
                <polygon points="75,25 90,40 90,90 75,75" strokeWidth="2"/>
                <polygon points="40,40 90,40 90,90 40,90" strokeWidth="2"/>
              </svg>
            </div>

            <div className="absolute top-1/3 right-1/4 w-8 h-8 animate-float-medium">
              <svg viewBox="0 0 100 100" className="w-full h-full stroke-white/30 fill-none">
                <polygon points="30,30 70,30 80,45 35,45" strokeWidth="2"/>
                <polygon points="30,30 35,45 35,80 30,70" strokeWidth="2"/>
                <polygon points="70,30 80,45 80,80 70,70" strokeWidth="2"/>
              </svg>
            </div>

            {/* Triangular Shapes - Top Right */}
            <div className="absolute top-8 right-8">
              {[...Array(6)].map((_, i) => (
                <div
                  key={`triangle-${i}`}
                  className="absolute animate-drift"
                  style={{
                    right: `${i * 40}px`,
                    top: `${i * 30}px`,
                    animationDelay: `${i * 0.5}s`
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 100 100" className="stroke-white/40 fill-none">
                    <polygon points="50,15 85,75 15,75" strokeWidth="3"/>
                  </svg>
                </div>
              ))}
            </div>

            {/* Circles and Dots - Right Side */}
            <div className="absolute right-8 top-1/4">
              {[...Array(8)].map((_, i) => (
                <div
                  key={`circle-${i}`}
                  className="absolute animate-pulse-slow"
                  style={{
                    top: `${i * 60}px`,
                    animationDelay: `${i * 0.3}s`
                  }}
                >
                  {i % 3 === 0 ? (
                    <div className="w-4 h-4 border-2 border-white/40 rounded-full"></div>
                  ) : i % 3 === 1 ? (
                    <div className="w-2 h-2 bg-white/60 rounded-full"></div>
                  ) : (
                    <svg width="16" height="16" viewBox="0 0 100 100" className="stroke-white/40 fill-none">
                      <polygon points="20,20 80,20 80,80 20,80" strokeWidth="4"/>
                      <polygon points="35,35 65,35 65,65 35,65" strokeWidth="2"/>
                    </svg>
                  )}
                </div>
              ))}
            </div>

            {/* Wire Frame Polyhedrons - Left Side */}
            <div className="absolute left-8 top-1/3">
              {[...Array(5)].map((_, i) => (
                <div
                  key={`poly-${i}`}
                  className="absolute animate-spin-slow"
                  style={{
                    top: `${i * 80}px`,
                    animationDelay: `${i * 1}s`
                  }}
                >
                  <svg width="24" height="24" viewBox="0 0 100 100" className="stroke-white/30 fill-none">
                    <polygon points="50,10 90,35 75,75 25,75 10,35" strokeWidth="2"/>
                    <line x1="50" y1="10" x2="35" y2="45" strokeWidth="1"/>
                    <line x1="50" y1="10" x2="65" y2="45" strokeWidth="1"/>
                    <line x1="35" y1="45" x2="65" y2="45" strokeWidth="1"/>
                    <line x1="35" y1="45" x2="25" y2="75" strokeWidth="1"/>
                    <line x1="65" y1="45" x2="75" y2="75" strokeWidth="1"/>
                  </svg>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Content Container */}
        <div className="relative z-10 flex flex-col px-5 md:px-0 py-12">
          {/* Header Section */}
          <div className="pt-0 md:pt-6 md:pb-6 pb-0">

            {/* Category Filter */}
            {/* <div className="flex justify-center mb-6 px-4">
              <div className="flex flex-wrap justify-center gap-2 md:gap-3">
                {categories.map((category) => (
                  <button
                    key={category}
                    onClick={() => setSelectedCategory(category)}
                    className={`px-3 md:px-4 py-2 rounded-full text-xs md:text-sm font-medium transition-all duration-300 backdrop-blur-md border whitespace-nowrap ${
                      selectedCategory === category
                        ? "bg-white/20 text-white border-white/40 shadow-lg scale-105"
                        : "bg-white/10 text-white/70 border-white/20 hover:bg-white/15 hover:text-white hover:scale-105"
                    }`}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </div> */}

            {/* Title */}
            <div className="text-center">
              <h1 className="font-[anzo] 
                            text-6xl sm:text-7xl md:text-9xl lg:text-[150px] 
                            font-bold 
                            text-transparent bg-clip-text 
                            bg-gradient-to-r from-blue-300 via-blue-300 to-blue-300 
                            uppercase 
                            leading-none">
                TOOLS
              </h1>

            </div>
          </div>

          {/* <div className="flex justify-center mb-0 px-4"> */}
              {/* <div className="flex flex-wrap justify-center gap-2 md:gap-3">
                {categories.map((category) => (
                  <button
                    key={category}
                    onClick={() => setSelectedCategory(category)}
                    className={`px-3 md:px-4 py-2 rounded-full text-xs md:text-sm font-medium transition-all duration-300 backdrop-blur-md border whitespace-nowrap ${
                      selectedCategory === category
                        ? "bg-white/20 text-white border-white/40 shadow-lg scale-105"
                        : "bg-white/10 text-white/70 border-white/20 hover:bg-white/15 hover:text-white hover:scale-105"
                    }`}
                  >
                    {category}
                  </button>
                ))}
              </div> */}
          {/* </div> */}

          {/* Skills Grid Section */}
          <div className="flex justify-center pt-8 pd-60 md:pb-80 px-4">

            <div className="w-full max-w-6xl">
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 md:gap-10">

                  {filteredSkills.map((skill, index) => (
                    <div
                      key={skill.name}
                      className={`group transition-all duration-700 ${
                    visibleSkills.includes(skills.indexOf(skill)) 
                      ? "translate-y-0 opacity-100" 
                      : "translate-y-8 opacity-0"
                  }`}

                    style={{ 
                      transitionDelay: `${index * 150}ms`,
                    }}
                  >
                    {/* Skill Card */}
                    <div className="relative 
                                  bg-white/5 
                                    backdrop-blur-xl 
                                    border border-white/20 
                                    rounded-2xl 
                                    p-6 
                                    h-40 
                                    flex flex-col 
                                    items-center 
                                    justify-center
                                    transition-all duration-500
                                    group-hover:scale-110
                                    group-hover:border-blue-300
                                    group-hover:shadow-[0_0_30px_rgba(147,197,253,0.5)]">

                      {/* Icon */}
                      <div className="mb-4 flex items-center justify-center">
                        <img
                          src={skill.icon}
                          alt={skill.name}
                          className="w-14 h-14 object-contain transition-all duration-500 group-hover:scale-125"
                        />
                      </div>

                      {/* Name */}
                      <h3 className="text-lg font-semibold text-white tracking-wide">
                        {skill.name}
                      </h3>

                      
                      {/* Category Badge */}
                      {/* <span className="inline-block px-2 py-1 text-xs font-medium text-white/80 bg-white/10 rounded-md mb-3 backdrop-blur-sm">
                        {skill.category}
                      </span> */}
                      
                      {/* Skill Level Bar */}
                      {/* <div className="relative">
                        <div className="flex justify-between items-center mb-2">
                          <span className="text-xs text-white/70">Level</span>
                          <span className="text-xs font-semibold text-white">{skill.level}%</span>
                        </div>
                        <div className="w-full bg-white/20 rounded-full h-1.5 overflow-hidden">
                          <div
                            className={`h-full bg-gradient-to-r ${skill.color} rounded-full transition-all duration-1200 ease-out`}
                            style={{ 
                              width: visibleSkills.includes(skills.indexOf(skill)) ? `${skill.level}%` : "0%",
                              transitionDelay: `${index * 200 + 400}ms`
                            }}
                          />
                        </div>
                      </div> */}

                      {/* Hover Effect Overlay */}
                      <div className="absolute inset-0 bg-gradient-to-br from-white/0 to-white/5 opacity-0 group-hover:opacity-100 transition-all duration-300 rounded-xl pointer-events-none" />
                    </div>

                    {/* Floating Indicator */}
                    <div className="absolute -top-1 -right-1 w-3 h-3 bg-gradient-to-br from-white/30 to-white/10 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes twinkle {
          0%, 100% { 
            opacity: 0.3;
            transform: scale(1);
          }
          50% { 
            opacity: 1;
            transform: scale(1.5);
          }
        }
        
        @keyframes slow-rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        
        @keyframes float-slow {
          0%, 100% { 
            transform: translateY(0px) rotate(0deg);
            opacity: 0.4;
          }
          50% { 
            transform: translateY(-20px) rotate(45deg);
            opacity: 0.8;
          }
        }
        
        @keyframes float-medium {
          0%, 100% { 
            transform: translateY(0px) rotate(0deg) scale(1);
            opacity: 0.3;
          }
          50% { 
            transform: translateY(-15px) rotate(-30deg) scale(1.2);
            opacity: 0.7;
          }
        }
        
        @keyframes drift {
          0%, 100% { 
            transform: translateX(0px) translateY(0px);
            opacity: 0.4;
          }
          25% { 
            transform: translateX(10px) translateY(-5px);
            opacity: 0.7;
          }
          50% { 
            transform: translateX(-5px) translateY(-10px);
            opacity: 0.8;
          }
          75% { 
            transform: translateX(-8px) translateY(5px);
            opacity: 0.6;
          }
        }
        
        @keyframes pulse-slow {
          0%, 100% { 
            opacity: 0.3;
            transform: scale(1);
          }
          50% { 
            opacity: 0.8;
            transform: scale(1.1);
          }
        }
        
        @keyframes spin-slow {
          from { 
            transform: rotate(0deg);
            opacity: 0.3;
          }
          to { 
            transform: rotate(360deg);
            opacity: 0.6;
          }
        }
        
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(200%); }
        }
        
        .animate-twinkle {
          animation: twinkle 3s ease-in-out infinite;
        }
        
        .animate-slow-rotate {
          animation: slow-rotate 60s linear infinite;
        }
        
        .animate-float-slow {
          animation: float-slow 8s ease-in-out infinite;
        }
        
        .animate-float-medium {
          animation: float-medium 6s ease-in-out infinite;
        }
        
        .animate-drift {
          animation: drift 12s ease-in-out infinite;
        }
        
        .animate-pulse-slow {
          animation: pulse-slow 4s ease-in-out infinite;
        }
        
        .animate-spin-slow {
          animation: spin-slow 20s linear infinite;
        }
        
        .animate-shimmer {
          animation: shimmer 2s linear infinite;
        }
        
        .line-clamp-1 {
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </div>
  );
};

export default Page5;